var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeavyRain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1903 25.4582C6.86548 23.9367 3.00013 19.3821 3.00013 14C3.00013 7.37258 8.86113 2 16.091 2C20.9365 2 25.1671 4.41319 27.4306 8H30.0001C34.9707 8 39.0001 12.0294 39.0001 17C39.0001 21.9706 34.9707 26 30.0001 26H15.2728C14.19 26 13.1519 25.8088 12.1903 25.4582Z",
    fill: "#D9DBE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0233 26.9556L19.5818 31.8705M33.0179 26.6294L28.4293 33.1826M13.0286 27.2819L6.1457 37.1118M14.993 38.4237L13.8459 40.062M5.03374 23.6083L1.59229 28.5232M12.1903 25.4582C6.86548 23.9367 3.00013 19.3821 3.00013 14C3.00013 7.37258 8.86113 2 16.091 2C20.9365 2 25.1671 4.41319 27.4306 8H30.0001C34.9707 8 39.0001 12.0294 39.0001 17C39.0001 21.9706 34.9707 26 30.0001 26H15.2728C14.19 26 13.1519 25.8088 12.1903 25.4582Z",
    stroke: "#6E7191",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeavyRain);
export default __webpack_public_path__ + "static/media/heavy-rain.792da64bfa57747a0455448e9e4020d0.svg";
export { ForwardRef as ReactComponent };